import { RiskFieldsTypeEnum } from '@/__generated__/graphql';
import { RiskAssessmentDrawerTable } from '../RiskAssessmentDrawerTable';

export const COFValueTab = () => {
  const selectedTab = RiskFieldsTypeEnum.Cof;

  return <RiskAssessmentDrawerTable selectedTab={selectedTab} />;
};
